import(/* webpackMode: "eager" */ "/vercel/path0/app/(auth-pages)/forgot-password/page.tsx");
